import React, { Component } from 'react';

class Customers extends Component {
    state = {}
    render() {
        return (
            <h1 className="text-left">Customers</h1>
        );
    }
}

export default Customers;